import {getQuery, postQuery} from "@/modules/common/utils";

const list = (params = {}) => {
  params.new_api = true
  return getQuery('/business/payments/v1/taxes',params)

}
const create = (params = {}) => {
  params.new_api = true
  return postQuery('/business/payments/v1/taxes',params)

}


export const taxService = {
  list,
  create
}
